var BaseModule = (function () {
    function BaseModule() {
        this.modules = [];
    }
    BaseModule.prototype.addModule = function (module) {
        this.modules.push(module);
    };
    BaseModule.prototype.getModuleByType = function (type) {
        var i = 0;
        var n = this.modules.length;
        for (; i < n; i++) {
            if (this.modules[i] instanceof type)
                return this.modules[i];
        }
        return undefined;
    };
    return BaseModule;
}());
export { BaseModule };



//////////////////
// WEBPACK FOOTER
// ./src/modules/commons/BaseModule.ts
// module id = cOS/
// module chunks = 10